import { Amplify } from "aws-amplify"
import { I18n } from "aws-amplify/utils"
import { translations } from "@aws-amplify/ui-react"

import { getEnv } from "@/lib/get-env"

let configured = false

export function ensureAmplifyConfigured(): void {
	if (configured) return

	const userPoolId = getEnv("VITE_PORTAL_COGNITO_USER_POOL_ID")
	const userPoolClientId = getEnv("VITE_PORTAL_COGNITO_CLIENT_ID")

	Amplify.configure({
		Auth: {
			Cognito: {
				userPoolId,
				userPoolClientId,
				loginWith: {
					email: true,
				},
				signUpVerificationMethod: "code",
				userAttributes: {
					email: {
						required: true,
					},
				},
				// Match the backend Cognito user pool password policy (see infra/modules/cognito/user-pool.ts)
				passwordFormat: {
					minLength: 12,
					requireLowercase: true,
					requireUppercase: true,
					requireNumbers: true,
					requireSpecialCharacters: true,
				},
			},
		},
	})

	I18n.putVocabularies(translations)
	I18n.putVocabulariesForLanguage("en", {
		"Account recovery requires verified contact information": "Get the verification code from your email",
	})

	configured = true
}
